/**
 * Coupon Selection Handler
 * Manages selectedCouponIds state driven by the coupon-selection-changed custom event.
 */
import { type ChatMessage } from './types.js';

export interface CouponSelectionContext {
  getMessages: () => ChatMessage[];
  getSelectedIds: () => string[];
  setSelectedIds?: (ids: string[]) => void;
}

export function handleCouponSelectionChanged(
  e: Event,
  ctx: CouponSelectionContext
): void {
  const detail = (e as CustomEvent<{ selectedIds: string[] }>).detail;
  ctx.setSelectedIds?.(detail.selectedIds);
}

/**
 * Returns the number of selected coupons, or -1 if there are no selectable coupons
 * in the current message list (used to control button state/label in the UI).
 */
export function getSelectedCouponCount(ctx: CouponSelectionContext): number {
  const hasSelectableCoupons = ctx.getMessages().some(
    msg => msg.coupons?.some(c => c.selectable)
  );
  return hasSelectableCoupons ? ctx.getSelectedIds().length : -1;
}
